<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
export default {
	props: {
		HandlingPersonInformation_Name: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tableData_picName:[],
			likeSearch:"",
			page: 1, //第几页
			limit: 10,
			radio_Name: 0,
			chooseallkh: {},
			total: '',
		};
	},
	created() {},
	mounted() {},
	watch: {
		HandlingPersonInformation_Name: function(indexVal, oldVal) {
			if (indexVal) {
				this.chooseallkh={}
				this.page=1
				this.limit=10
				this.radio_Name = 0;
				this.likeSearch = '';
				this.total=0
				this.getCustomerList();
			}
		}
	},
	methods: {
		/* 客户主数据选择 */
		Handling() {
		this.$emit("Handling",this.chooseallkh)
		},
		forsurekhDblclick(row, column, event) {
		 this.$emit("Handling",row)
		},
		radiochangekhClick(row, column, event) {
		  this.radio_Name = row.index;
		  this.chooseallkh = row;
		},
		radiochangekh(val) {
		    this.chooseallkh = val;
		},
		handleSizeChange(val) {
		    this.pagenum = val;
		    this.getCustomerList();
		},
		handleCurrentChange(val) {
		    this.page = val;
		    this.getCustomerList();
		},
		forserchgroup() {
		    this.getCustomerList();
		},
	
		closedHandlingPersonInformation_Name() {
			this.$emit('closedHandlingPersonInformation_Name', '');
		},

		getCustomerList() {
			this.$https.fetchPost('sys/admin/getAgentByCode').then(res => {
				for (let i=0;i<res.data.data.length;i++){
				  res.data.data[i].index=(i+1);
				}
				this.tableData_picName = res.data.data;
				// this.total = res.data.count;
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
